<template>
  <div v-if="items" class="row justify-content-center">
    <div class="col-md-6 col-lg-3">
      <div class="card report-card">
        <div class="card-body">
          <div class="row d-flex justify-content-center">
            <div class="col">
              <p class="text-dark mb-1 font-weight-semibold">کل کابران معرفی شده</p>
              <h3 class="my-2">{{(items.n_invite_user?items.n_invite_user:'0')}}</h3>
            </div>

          </div>
        </div><!--end card-body-->
      </div><!--end card-->
    </div> <!--end col-->
    <div class="col-md-6 col-lg-3">
      <div class="card report-card">
        <div class="card-body">
          <div class="row d-flex justify-content-center">
            <div class="col">
              <p class="text-dark mb-1 font-weight-semibold">کابران معرفی شده امروز</p>
              <h3 class="my-2">{{(items.n_today_user?items.n_today_user:'0')}}</h3>
            </div>
          </div>
        </div><!--end card-body-->
      </div><!--end card-->
    </div> <!--end col-->
    <div class="col-md-6 col-lg-3">
      <div class="card report-card">
        <div class="card-body">
          <div class="row d-flex justify-content-center">
            <div class="col">
              <p class="text-dark mb-1 font-weight-semibold">کابران معرفی شده هفته</p>
              <h3 class="my-2">{{(items.n_week_user?items.n_week_user:'0')}}</h3>
            </div>
          </div>
        </div><!--end card-body-->
      </div><!--end card-->
    </div> <!--end col-->
    <div class="col-md-6 col-lg-3">
      <div class="card report-card">
        <div class="card-body">
          <div class="row d-flex justify-content-center">
            <div class="col">
              <p class="text-dark mb-1 font-weight-semibold">کابران معرفی شده ماه</p>
              <h3 class="my-2">{{(items.n_month_user?items.n_month_user:'0')}}</h3>
            </div>
          </div>
        </div><!--end card-body-->
      </div><!--end card-->
    </div> <!--end col-->
  </div><!--end row-->
</template>

<script>
import {mapActions} from "vuex";
import {AppApi} from "@/api/AppApi";

export default {
name: "visitorDashboard",
  data()
  {
    return{
      items : null,
    }
  },
  mounted()
  {
    this.setPageLoading(false);
    this.initPage();
  },
  methods: {
    ...mapActions('app', {
      setPageLoading: 'setPageLoading',
    }),
    initPage()
    {
      this.items = null;
      AppApi.getProfileItems().then(result=>{
        this.items = result;
      });
    }
  },
}
</script>

<style scoped>

</style>